<!-- app页面——部门回收站 -->
<template>
  <div class="deptRecycleH5">
    <van-nav-bar title="回收站" left-arrow @click-left="toBack" />
    <div class="content">
      <!-- 文档列表 -->
      <van-pull-refresh class="folderList" v-model="refreshing" @refresh="onRefresh" v-loading="loading">
        <div class="folderItem" v-for="item in deptRecycleList" :key="item.folderId">
          <oneFileFolder :key="item.folderId" :item="item" @moreOpen="moreOpen(item)"></oneFileFolder>
        </div>
        <div class="empty" v-if="!deptRecycleList.length">暂无数据</div>
      </van-pull-refresh>
    </div>
    <!-- 更多弹框 -->
    <deptRecycleMore ref="deptRecycleMore" @toRefresh="toRefresh" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import oneFileFolder from "../../components/oneFileFolder.vue";
import deptRecycleMore from "./deptRecycleMore.vue";

export default {
  components: { oneFileFolder, deptRecycleMore },
  data() {
    return {
      deptRecycleList: [], // 企业回收站列表
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getDeptRecycleList();
  },
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },

    // 获得企业回收站列表
    async getDeptRecycleList() {
      this.loading = true;
      try {
        let enterpriseId = this.enterpriseId;
        const res = await secondaryMenuService.queryEnterpriseDeptRecycle(enterpriseId);
        this.deptRecycleList = res.data || [];
      } finally {
        this.loading = false;
      }
    },
    // 刷新列表
    toRefresh() {
      this.getDeptRecycleList();
    },
    // 下拉刷新
    async onRefresh() {
      try {
        await this.getDeptRecycleList();
      } finally {
        this.refreshing = false;
      }
    },

    // 点击... 打开更多
    moreOpen(item) {
      if (item.isFolder == 1) this.$refs.deptRecycleMore.setFolderPrivi(item);
      else this.$refs.deptRecycleMore.setFilePrivi(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.deptRecycleH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
  }
}

.folderList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--info-color)9;
    font-size: 16px;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
